import React, { useEffect } from "react";
import "./ConfirmationModal.scss";

import { FiTrash, FiX, FiAlertTriangle } from "react-icons/fi";

// Reusable Confirmation Modal Component
 export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Deletion",
  description = "Are you sure you want to delete this item?",
  warningNote = "",
  confirmButtonText = "Delete",
  cancelButtonText = "Cancel",
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-confirmation-modal">
      <div className="modal-content">
        <div className="modal-header">
          <FiAlertTriangle className="warning-icon" />
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>
            <FiX />
          </button>
        </div>
        <div className="modal-body">
          <p>{description}</p>
          <p className="warning-note">{warningNote}</p>
        </div>
        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            {cancelButtonText}
          </button>
          <button className="delete-btn" onClick={onConfirm}>
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};
